// extracted by mini-css-extract-plugin
export default {"root":"InlineSelect_root__kfNZ+","trigger":"InlineSelect_trigger__SbXYL","menu":"InlineSelect_menu__fNRbY"};